import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/wifi-off.vue
var s = {
	name: "DtIconWifiOff",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--wifi-off"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Wifi Off",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [...t[0] || (t[0] = [i("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M7.988 5.382a.5.5 0 0 1 .68-.194c.448.25.86.56 1.221.924a.5.5 0 0 1-.708.706 4.5 4.5 0 0 0-1-.756.5.5 0 0 1-.193-.68ZM.646.646a.5.5 0 0 1 .708 0L3.43 2.723l.016.017 2.022 2.022a.492.492 0 0 1 .01.01l5.875 5.874a.5.5 0 0 1-.708.708l-2.66-2.662a.5.5 0 0 1-.585-.085 2 2 0 0 0-2.8 0 .5.5 0 0 1-.7-.714 3 3 0 0 1 2.449-.837l-1.39-1.39a4.5 4.5 0 0 0-2.105 1.188.5.5 0 1 1-.708-.708 5.5 5.5 0 0 1 2.013-1.28L2.976 3.683a7 7 0 0 0-1.642 1.1.5.5 0 0 1-.668-.745 8 8 0 0 1 1.566-1.099L.646 1.354a.5.5 0 0 1 0-.708Zm10.02 4.107a6.993 6.993 0 0 0-5.291-1.755.5.5 0 0 1-.09-.996 7.993 7.993 0 0 1 6.048 2.005.5.5 0 0 1-.666.746ZM5.5 10a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=wifi-off.js.map